document.addEventListener('DOMContentLoaded', function () {

  var wrap = document.getElementById('mr-wrap');
  if (!wrap) return;

  var ADMIN_EMAIL = wrap.dataset.email;
  var current = 0;

  // ── Navigation ──────────────────────────────────────────
  window.mrGoTo = function (step) {
    document.getElementById('mr-panel-' + current).classList.remove('visible');
    current = step;
    document.getElementById('mr-panel-' + current).classList.add('visible');
    mrUpdateProgress();
    window.scrollTo({
      top: wrap.getBoundingClientRect().top + window.scrollY - 20,
      behavior: 'smooth'
    });
  };

  function mrUpdateProgress() {
    for (var i = 0; i < 4; i++) {
      var dot = document.getElementById('mr-dot-' + i);
      var lbl = document.getElementById('mr-lbl-' + i);
      dot.classList.remove('active', 'done');
      lbl.classList.remove('active', 'done');
      if (i < current) {
        dot.classList.add('done');
        dot.innerHTML = '&#10003;';
        lbl.classList.add('done');
      } else if (i === current) {
        dot.classList.add('active');
        dot.textContent = i + 1;
        lbl.classList.add('active');
      } else {
        dot.textContent = i + 1;
      }
      if (i < 3) {
        document.getElementById('mr-line-' + i).classList.toggle('done', i < current);
      }
    }
  }

  // ── Chip toggle ─────────────────────────────────────────
  window.mrToggle = function (el, groupId, single) {
    if (single) {
      document.querySelectorAll('#' + groupId + ' .mr-chip').forEach(function (c) {
        c.classList.remove('selected');
      });
      el.classList.add('selected');
    } else {
      el.classList.toggle('selected');
    }
  };

  // ── Rating toggle ────────────────────────────────────────
  window.mrRating = function (groupId, el) {
    document.querySelectorAll('#' + groupId + ' .mr-rating-btn').forEach(function (b) {
      b.classList.remove('selected');
    });
    el.classList.add('selected');
  };

  // ── Helpers ──────────────────────────────────────────────
  function mrChips(id) {
    return Array.from(document.querySelectorAll('#' + id + ' .mr-chip.selected'))
      .map(function (c) { return c.textContent.trim(); }).join(', ') || '-';
  }

  function mrRatingVal(id) {
    var s = document.querySelector('#' + id + ' .mr-rating-btn.selected');
    return s ? s.textContent + ' / 5' : '-';
  }

  function mrCollect() {
    return {
      name:          (document.getElementById('mr-first-name').value + ' ' + document.getElementById('mr-last-name').value).trim() || '-',
      email:         document.getElementById('mr-email').value          || '-',
      ageRange:      document.getElementById('mr-age').value            || '-',
      device:        document.getElementById('mr-device').value         || '-',
      skinType:      mrChips('mr-skin-type'),
      concerns:      mrChips('mr-concerns'),
      skinCondition: mrRatingVal('mr-skin-condition'),
      primaryGoal:   mrChips('mr-primary-goal'),
      usageDuration: document.getElementById('mr-usage-duration').value || '-',
      frequency:     mrChips('mr-frequency'),
      satisfaction:  mrRatingVal('mr-satisfaction'),
      products:      mrChips('mr-products'),
      sensitivities: document.getElementById('mr-sensitivities').value  || '-',
      contact:       mrChips('mr-contact'),
      notes:         document.getElementById('mr-notes').value          || '-'
    };
  }

  // ── Email builder ────────────────────────────────────────
  function mrBuildEmail(d) {
    var rows = [
      ['Name', d.name], ['Email', d.email], ['Age Range', d.ageRange], ['Device Owned', d.device],
      ['Skin Type', d.skinType], ['Skin Concerns', d.concerns], ['Skin Condition', d.skinCondition],
      ['Primary Goal', d.primaryGoal], ['Usage Duration', d.usageDuration],
      ['Usage Frequency', d.frequency], ['Satisfaction', d.satisfaction],
      ['Current Products', d.products], ['Sensitivities', d.sensitivities],
      ['Preferred Contact', d.contact], ['Additional Notes', d.notes]
    ];
    var tr = rows.map(function (r) {
      return '<tr>'
        + '<td style="padding:10px 16px;font-size:10px;font-family:Arial,sans-serif;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#999;white-space:nowrap;border-bottom:1px solid #f5f5f5;vertical-align:top">' + r[0] + '</td>'
        + '<td style="padding:10px 16px;font-size:13px;font-family:Arial,sans-serif;color:#000;border-bottom:1px solid #f5f5f5">' + r[1] + '</td>'
        + '</tr>';
    }).join('');

    return '<!DOCTYPE html><html><body style="margin:0;padding:0;background:#f5f5f3;font-family:Arial,sans-serif">'
      + '<table width="100%" cellpadding="0" cellspacing="0" style="background:#f5f5f3;padding:48px 24px"><tr><td align="center">'
      + '<table width="600" cellpadding="0" cellspacing="0" style="background:#fff;border:1px solid #e8e8e8">'
      + '<tr><td style="padding:36px 40px;border-bottom:4px solid #000">'
      + '<p style="margin:0 0 6px;font-size:10px;letter-spacing:4px;text-transform:uppercase;color:#b8986a">Glamour New York</p>'
      + '<h1 style="margin:0;font-size:22px;font-weight:400;color:#000;letter-spacing:1px;font-family:Georgia,serif">A customer has just submitted a form!</h1>'
      + '</td></tr>'
      + '<tr><td style="padding:32px 40px 24px">'
      + '<p style="margin:0 0 6px;font-size:10px;letter-spacing:3px;text-transform:uppercase;color:#b8986a;font-weight:700">New Submission</p>'
      + '<h2 style="margin:0 0 24px;font-size:16px;font-weight:700;color:#000;letter-spacing:3px;text-transform:uppercase">Maximize Results</h2>'
      + '<p style="margin:0 0 24px;font-size:13px;color:#777;line-height:1.7">Go to the app admin page to check details.</p>'
      + '<p style="margin:0 0 10px;font-size:10px;letter-spacing:3px;text-transform:uppercase;color:#bbb;font-weight:700">More Information</p>'
      + '<table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #e8e8e8">' + tr + '</table>'
      + '</td></tr>'
      + '<tr><td style="padding:24px 40px;border-top:1px solid #f0f0f0;background:#fafaf8">'
      + '<p style="margin:0;font-size:12px;color:#aaa;line-height:1.7">If you have any questions, reply to this email or contact us at '
      + '<a href="mailto:' + ADMIN_EMAIL + '" style="color:#b8986a;text-decoration:none">' + ADMIN_EMAIL + '</a></p>'
      + '</td></tr></table></td></tr></table></body></html>';
  }

  function mrBase64(str) {
    return btoa(unescape(encodeURIComponent(str)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function mrSendEmail(d) {
    var subject = 'You have a new submission MAXIMIZE RESULTS!';
    var raw = [
      'To: ' + ADMIN_EMAIL,
      'Subject: ' + subject,
      'MIME-Version: 1.0',
      'Content-Type: text/html; charset=utf-8',
      '',
      mrBuildEmail(d)
    ].join('\r\n');

    return fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        model: 'claude-sonnet-4-20250514',
        max_tokens: 1000,
        messages: [{ role: 'user', content: 'Use Gmail MCP to send this pre-encoded email. Call gmail_send_email with raw="' + mrBase64(raw) + '". Confirm with "sent".' }],
        mcp_servers: [{ type: 'url', url: 'https://gmail.mcp.claude.com/mcp', name: 'gmail' }]
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (json) {
      var text = (json.content || []).map(function (b) { return b.text || ''; }).join('');
      if (!text.toLowerCase().includes('sent') && !text.toLowerCase().includes('success') && !text.toLowerCase().includes('message')) {
        throw new Error('uncertain');
      }
    });
  }

  // ── Submit ───────────────────────────────────────────────
  window.mrSubmit = function () {
    var area = document.getElementById('mr-submit-area');
    area.innerHTML = '<div class="mr-sending"><div class="mr-spinner"></div><span>Sending your submission...</span></div>';
    var d = mrCollect();
    mrSendEmail(d)
      .then(function () { mrShowSuccess(d, true); })
      .catch(function () { mrShowSuccess(d, false); });
  };

  function mrShowSuccess(d, emailSent) {
    var summary = [
      { k: 'Name', v: d.name }, { k: 'Email', v: d.email },
      { k: 'Age Range', v: d.ageRange }, { k: 'Device', v: d.device },
      { k: 'Skin Type', v: d.skinType }, { k: 'Concerns', v: d.concerns },
      { k: 'Primary Goal', v: d.primaryGoal }, { k: 'Frequency', v: d.frequency },
      { k: 'Contact via', v: d.contact }
    ];
    document.getElementById('mr-summary').innerHTML = summary.map(function (r) {
      return '<div class="mr-summary-row"><span class="mr-summary-key">' + r.k + '</span><span class="mr-summary-val">' + r.v + '</span></div>';
    }).join('');
    document.getElementById('mr-email-notice').textContent = emailSent
      ? 'A notification has been sent to ' + ADMIN_EMAIL
      : 'Your submission was recorded. Our team will be in touch soon.';
    document.getElementById('mr-panel-' + current).classList.remove('visible');
    document.getElementById('mr-progress').style.display = 'none';
    document.getElementById('mr-panel-success').classList.add('visible');
    window.scrollTo({
      top: wrap.getBoundingClientRect().top + window.scrollY - 20,
      behavior: 'smooth'
    });
  }

  // ── Reset ────────────────────────────────────────────────
  window.mrReset = function () {
    document.querySelectorAll('.mr-input, .mr-textarea').forEach(function (el) { el.value = ''; });
    document.querySelectorAll('.mr-select').forEach(function (el) { el.selectedIndex = 0; });
    document.querySelectorAll('.mr-chip.selected').forEach(function (el) { el.classList.remove('selected'); });
    document.querySelectorAll('.mr-rating-btn.selected').forEach(function (el) { el.classList.remove('selected'); });
    document.getElementById('mr-submit-area').innerHTML = '<button class="mr-btn-next" type="button" onclick="mrSubmit()">Submit</button>';
    document.getElementById('mr-panel-success').classList.remove('visible');
    document.getElementById('mr-progress').style.display = 'block';
    current = 0;
    document.getElementById('mr-panel-0').classList.add('visible');
    mrUpdateProgress();
  };

});
